module.exports = __webpack_public_path__ + "static/media/PieChart.262eedc9.svg";